/* P1 draft, 2026-11-02. Keep storefront content links in the active Shopify market. */
(function () {
  'use strict';
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
  if (typeof root !== 'string' || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(root) || root === '/') return;
  var bareRoot = root.slice(0, -1);
  var contentPath = /^\/(?:pages|products|collections|blogs|policies)(?:\/|$)|^\/(?:search|cart)(?:\/|$)|^\/$/;
  var skip = '#store-selector, [data-localization-form], localization-form, form[action*="/localization"], [data-flite-preserve-market]';
  function localize(anchor) {
    if (!anchor || anchor.tagName !== 'A' || anchor.hasAttribute('download') || anchor.closest(skip)) return;
    var href = anchor.getAttribute('href');
    if (!href || /^(?:#|\?|mailto:|tel:|javascript:|data:)/i.test(href.trim())) return;
    var url;
    try { url = new URL(href, document.baseURI); } catch (_) { return; }
    if (!/^https?:$/.test(url.protocol) || url.origin !== window.location.origin || url.username || url.password) return;
    if (url.pathname === bareRoot || url.pathname.indexOf(root) === 0 || !contentPath.test(url.pathname)) return;
    // Root links with nogeo are the existing deliberate country/store switch.
    if (url.pathname === '/' && url.searchParams.has('nogeo')) return;
    anchor.setAttribute('href', root + url.pathname.slice(1) + url.search + url.hash);
  }
  function scan(node) {
    if (node.nodeType !== 1) return;
    localize(node);
    node.querySelectorAll('a[href]').forEach(localize);
  }
  function init() {
    if (document.body) scan(document.body);
    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') localize(record.target);
        else record.addedNodes.forEach(scan);
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  }
  ['click', 'auxclick'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (event.target.closest) localize(event.target.closest('a[href]'));
    }, true);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
